import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage, Messaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyAuezzSWSfrpnvxxxRVSI4u0lAtZpCnGpg",
  authDomain: "investor-database-c0c49.firebaseapp.com",
  projectId: "investor-database-c0c49",
  storageBucket: "investor-database-c0c49.firebasestorage.app",
  messagingSenderId: "952602799897",
  appId: "1:952602799897:web:e4e57ca14c86294cbc9f88"
};

let app: any = null;
let messaging: Messaging | null = null;

export const isNotificationSupported = (): boolean => {
  return 'Notification' in window && 'serviceWorker' in navigator;
};

export const initializeMessaging = async (): Promise<Messaging | null> => {
  if (!isNotificationSupported()) {
    console.log('❌ Push notifications not supported');
    return null;
  }
  
  try {
    if (!app) {
      app = initializeApp(firebaseConfig, 'push-notifications');
    }
    messaging = getMessaging(app);
    return messaging;
  } catch (error) {
    console.error('❌ Failed to initialize messaging:', error);
    return null;
  }
};

export const requestNotificationPermission = async (investorId: string, apiUrl: string): Promise<string | null> => {
  if (!isNotificationSupported()) return null;
  
  try {
    const permission = await Notification.requestPermission();
    
    if (permission !== 'granted') {
      console.log('❌ Notification permission denied');
      return null;
    }
    
    console.log('✅ Notification permission granted');
    
    if (!messaging) {
      await initializeMessaging();
    }
    
    if (!messaging) return null;
    
    const token = await getToken(messaging, {
      vapidKey: 'BK5njNvdnlt-lqfo3razT4SoVYjFaANjT_HZLd_ik2A5fEhSA'
    });
    
    if (token) {
      console.log('✅ FCM Token registered');
      await saveTokenToServer(token, investorId, apiUrl);
      return token;
    }
    
    return null;
  } catch (error) {
    console.error('❌ Failed to get notification permission:', error);
    return null;
  }
};

const saveTokenToServer = async (token: string, investorId: string, apiUrl: string): Promise<void> => {
  try {
    await fetch(`${apiUrl}/push-tokens`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        token,
        investorId,
        platform: 'web',
        createdAt: new Date().toISOString()
      })
    });
    console.log('✅ FCM token saved to server');
  } catch (error) {
    console.error('❌ Failed to save token:', error);
  }
};

export const onForegroundMessage = (callback: (payload: any) => void): void => {
  if (!messaging) return;
  
  onMessage(messaging, (payload) => {
    console.log('📬 Foreground message:', payload);
    callback(payload);
  });
};

export const getPermissionStatus = (): NotificationPermission | 'unsupported' => {
  if (!isNotificationSupported()) return 'unsupported';
  return Notification.permission;
};